import styled from '@emotion/styled';

const FileChipFilename = styled('span')(({ theme }) => ({
  paddingLeft: 12,
  paddingRight: 12,
  maxWidth: 154,
  height: '100%',
  lineHeight: '32px',
  verticalAlign: 'middle',
  fontSize: 13,
  fontWeight: 500,
  color: theme.isDark ? theme.palette.text.secondary : undefined,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  display: 'block',
}));

export default FileChipFilename;
